import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { HeadingTag, Title } from '@shared/components/title/models';
import { TitleStylePipe } from '@shared/components/title/pipes';

@Component({
  selector: 'app-title',
  imports: [TitleStylePipe],
  templateUrl: './title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleComponent {
  title = input.required<Title>();
  size = input.required<HeadingTag>();
}
